import { HorseTraderInitialLogo } from '../../images';
import { IntialStyledContainer, IntialStyledLogo, VersionContainerStyled, VersionStyled } from './styled';

export const InitialScreen = () => {
  return (
    <IntialStyledContainer>
      <IntialStyledLogo>
        <HorseTraderInitialLogo width='50%' height='50%'></HorseTraderInitialLogo>
        <VersionContainerStyled>
          <VersionStyled>Version 1.5</VersionStyled>
        </VersionContainerStyled>
      </IntialStyledLogo>
    </IntialStyledContainer>
  );
};
